
function $translationService($q, $http, localStorageService, $Config) {
    this.$q = $q;
    this.$http = $http;
    this.localStorageService = localStorageService;
    this.$Config = $Config;

    this._loadedLanguageCode = null;

    this._isLoading = false;
    this.dic = {};

    this._defaultLoaded = false;
    this._defaultDic = {};
}
$translationService.$inject = ['$q','$http', 'localStorageService', '$Config'];
$translationService.prototype = {
    isTranslationLoaded () {
        return this._loadedLanguageCode !== null;
    },

    isLoading () {
        return this._isLoading;
    },

    // if caller dont pass language code then by default get from current language
    loadTranslation (code) {
        
        var languageCode = 'en';
        if (code) {
            languageCode = code;
        } else {
            languageCode = this.getCurrentLanguageCode();
        }      

        if (this._loadedLanguageCode === languageCode) {
            return this.$q.resolve(true);
        }

        // console.log('----load translation - ', code);        

        var _self = this;

        return this.$q(angular.bind(this, function (resolve, reject) {
            if (this._isLoading) {
                reject('loading');
                return;
            }
            
            this._isLoading = true;
            var version = this.getAppVersionInfor();

            var requests = [];
            if (!this._defaultLoaded) {
                // console.log('----load default translation');
                requests.push(this.$http.get(`languages/en.json?v=${version}`,{
                    responseType: "json"
                }));
            }

            if (languageCode != 'en') {
                requests.push(this.$http.get(`languages/${this.toSupportedLanguage(languageCode)}.json?v=${version}`,{
                    responseType: "json"
                }));
            }

            // this is a case that user switch to EN and nothing to load
            if (requests.length == 0) {

                this.dic = {};

                this._loadedLanguageCode = languageCode;
                this.setCurrentLanguageCode(languageCode);
                this.updateMomentLocale(languageCode);

                this._isLoading = false;

                //  timeout to simulate request so that UI can re-render
                setTimeout(() => {
                    resolve(true);    
                }, 100);                

                console.log('>>> Switch to default language.');

                return;
            }

            this.$q.all(requests).then(function(responses) {
                if (!_self._defaultLoaded) {
                    _self._defaultDic = responses[0].data;
                    _self._defaultLoaded = true;
                }

                if (responses.length > 1) {
                    _self.dic = responses[1].data;
                } else {
                    _self.dic = responses[0].data;
                }

                _self._loadedLanguageCode = languageCode;


                _self.setCurrentLanguageCode(languageCode);
                _self.updateMomentLocale(languageCode);

                _self._isLoading = false;
                resolve(true);
            },function (error){
                _self._isLoading = false;
                reject(error);
            });
            

            // old code not work with default language "en"
            // this.$http.get(`languages/${this.toSupportedLanguage(languageCode)}.json?v=${version}`,{
            //     responseType: "json"
            // }).then(function (response) {
            //     _self.dic = response.data;
            //     _self._loadedLanguageCode = languageCode;

            //     _self.setCurrentLanguageCode(languageCode);
            //     _self.updateMomentLocale(languageCode);

            //     _self._isLoading = false;
            //     resolve(true);
            // }, function (error){
            //     _self._isLoading = false;
            //     reject(error);
            // });
        }));
    },

    // Need to make sure in is the language code we supported and the file is existed, otherwise fall back to "en"
    toSupportedLanguage (code) {
        if (['en', 'fr', 'nl'].indexOf(code) >= 0) {
            return code;
        }

        console.warn(`Language "${code}" not supported, fallback to "en".`);
        return 'en';
    },

    updateMomentLocale (code) {

        // for firendly date, we need to overide the default of moment so that it does not show time
        let overrideConfig ={
            calendar: {
                lastDay: `[${this.getTranslation('calendar_Yesterday')}]`,
                sameDay: `[${this.getTranslation('calendar_Today')}]`,
                nextDay: `[${this.getTranslation('calendar_Tomorrow')}]`,
                lastWeek: 'ddd, Do MMMM YYYY',
                nextWeek: 'ddd, Do MMMM YYYY',
                sameElse: 'ddd, Do MMMM YYYY'
            }
        }        

        moment.locale(code, overrideConfig);
    },

    setCurrentLanguageCode (code) {
        var infor = this.localStorageService.get("localinfo");
        if (infor) {
            infor.languageCode = code;
            this.localStorageService.set("localinfo", infor);
        } else {
            infor = {
                languageCode: code
            }
            this.localStorageService.set("localinfo", infor);
        }
    },

    getCurrentLanguageCode () {
        var infor = this.localStorageService.get("localinfo");
        if (infor) {
            if (!infor.languageCode) {
                infor.languageCode = 'en';
                this.localStorageService.set("localinfo", infor);
            }
        } else {
            infor = {
                languageCode: 'en'
            }
            this.localStorageService.set("localinfo", infor);
        }

        return infor.languageCode;
    },

    getTranslation  (key) {
        return this.dic[key] || this._defaultDic[key] || `?${key}?`;
        // return `?${key}?`;
    },

    formatTranslation  (key, param1, param2, param3, param4) {
        var text = this.getTranslation(key);

        if (param1) {
            text = text.replace(/\{0\}/g, param1);
        }

        if (param2) {
            text = text.replace(/\{1\}/g, param2);
        }

        if (param3) {
            text = text.replace(/\{2\}/g, param3);
        }

        if (param4) {
            text = text.replace(/\{3\}/g, param4);
        }
        
        return text;
    },

    existTranslation  (key) {
        return !!this.dic[key] || !!this._defaultDic[key];
    },
   
    getAppVersionInfor () {
        var buildVersion = Date.now().toString();

        var applicationVersion = this.$Config.version;

        if (applicationVersion) {
            let tokens = applicationVersion.split(' ');
            if (tokens.length > 1) {
                return tokens[tokens.length - 1];
            }

            return applicationVersion.trim();
        }

        return buildVersion;
    }
}

angular.module('shared').service('$translationService', $translationService);
